import { useEffect, useRef, useState } from "react";
import { getTokenFromTokenStore } from "../../config/Authentication";
import { useAppContext } from "../../contexts/AppContext";
import downloadImg from '../../images/icons8-download-96.png';

import { Spinner } from "@fluentui/react-components";
import { BugFilled, CheckmarkCircleFilled } from "@fluentui/react-icons";
import axios, { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import styles from './Downloader.module.scss';
export interface DownloaderProps {
    authenticationRequired: boolean;
    /** The GUID of the downloaded item */
    itemGuid: string;
}

interface DownloadProgress {
    total?: number,
    loaded?: number,
    percentCompleted?: number
}

const Downloader = (props: DownloaderProps) => {
    const {
        authenticationRequired,
        itemGuid
    } = props;
    const navigate = useNavigate();
    const { logger, environment, setCorrelationId } = useAppContext();
    const [initializing, setDownloading] = useState<boolean>(true);
    const [error, setError] = useState<Nullable<string>>();
    const timer = useRef<any>();
    const [showYouCanClose, setShowYouCanClose] = useState(false);
    //const [progress, setProgress] = useState<DownloadProgress>();

    const downloadFile = (url: string) => {
        if (!itemGuid) {
            setDownloading(false);
            setError("Missing url parameters 'guid'");
            return;
        }

        logger.logDebug(`Starting download from '${url}'...`);


        setDownloading(true);
        let correlationId: string | undefined | null;

        try {
            const link = document.createElement('a');
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute

                link.setAttribute('href', url);
                link.setAttribute('download', '');
                //link.setAttribute('target', '_blank');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            if (correlationId) setCorrelationId(correlationId)
            setDownloading(false);
            startCountdown();
        } catch (error) {
            logger.logError(error);
            setError("Unfortunately, the download failed. Try it again or contact the DHI support.");
            setDownloading(false);
        }
    }


    const getProtectedFileUrl = async (token: string): Promise<string> => {

        const url = `${environment.API_URL}/api/Downloads/registerauthenticateddownload?downloadlistingGuid=${itemGuid}`;

        // const requestHeadersAx: AxiosHeaders = new AxiosHeaders();
        // requestHeadersAx.add('Authorization', `Bearer ${token}`);
        const headers = { 'Authorization': `Bearer ${token}` };

        try {
            const response: AxiosResponse = await axios.post(url, {}, { headers });

            if (response.status !== 201) throw new Error(response.statusText);
            const locationHeader = response.headers['location'];
            const correlationId = response.headers['x-correlation-id'];
            if (correlationId) setCorrelationId(correlationId);
            return `${locationHeader}`;

        } catch (error) {
            logger.logError(error);
            setError("Unfortunately, the download failed. Try it again or contact the DHI support.");
            return '';
        }
    }

    const startCountdown = () => {
        timer.current = setTimeout(() => setShowYouCanClose(true), 5000);
    }



    useEffect(() => {

        let isMounted = true;
        if (authenticationRequired) {
            // if authentication required, load the token from Azure authentication
            getTokenFromTokenStore()
                .then(token => {
                    if (!token) throw new Error(`Token not obtained`);
                    logger.logDebug(`token: ${token}`)
                    if (!isMounted) return;
                    return getProtectedFileUrl(token)
                }).then(url => {
                    if (!url) throw new Error(`Download url not obtained`);
                    if (!isMounted) return;
                    downloadFile(url);
                }).catch((e) => {
                    if (e.message === "Unauthorized") {
                        navigate({
                            pathname: '/protected',
                            search: window.location.search,
                        })
                    } else {
                        setError("Unfortunately, something went wrong. Please, try it again or contact the hotline.")
                    }

                });


        }
        else {
            const url = `${environment.API_URL}/api/Downloads/downloadfile?downloadlistingGuid=${itemGuid}`;

            downloadFile(url);
        }

        return () => { isMounted = false }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return <div className={styles.downloader}>
        <div className={styles.pageCenter}>
            {initializing && <div className={styles.row}><Spinner className={styles.icon} />Preparing download ...</div>}
            {!initializing && error && <div className={styles.error}><BugFilled className={styles.icon} />{error}</div>}
            {!initializing && !error && <>
                <div>
                    <img src={downloadImg} alt="downloadImg" /></div>
                <div className={styles.happy}><CheckmarkCircleFilled className={styles.icon} /> Download started</div>
                {showYouCanClose && <div className={styles.happy}>You can close the window now</div>}
            </>}

        </div>

    </div>
}

export default Downloader;

